<template>
  <div class="hearder">
    <div class="hearder-wrapper">
      <div>
        <img class="header-logo" src="../assets/images/header-logo.png" alt="证券数据分析,资产管理数据分析,金融大数据分台,金融数字化转型">
        <router-link :to="{ path: '/index' }">首页</router-link>
        <router-link :to="{ path: '/productservice' }">产品与服务</router-link>
        <router-link :to="{ path: '/contactus' }">关于我们</router-link>
      </div>
      <div>
        <!-- <div class="phone-wrapper">
          <img class="phone-avatar" src="../assets/images/bbc13.png" />
          <div>153-4581-0586</div>
        </div> -->

          <template v-if="!token">
          <router-link :to="{ path: '/login' }">登录</router-link>
          <router-link :to="{ path: '/register' }">注册</router-link>
        </template>
        <template v-else>
          <img class="user-avatar" src="../assets/images/head-portrait.png" />
          <router-link :to="{ path: '/personCenter' }">个人中心</router-link>
        </template>

        <!-- <router-link :to="{path:'/personCenter'}">personCenter</router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Hearder",
  props: {
    msg: String,
  },
  data() {
    return {
      userInfo: {},
    };
  },
  computed: {
    ...mapGetters(['token'])
  },
  watch:{
    $route(to,from){
      if(to.path == '/index'){
        // let res = this.getUserInfo().then(res=>{
        //   console.log(res,'kkkkkkk')
        //   this.userInfo = res.body;
        // })
      }
      if ($(window).width() > 760) {
        if(to.path == '/productservice'){
          this.$router.go(0);
        }
      }
    }
  },
  mounted () {
    if(this.token){
      let res = this.getUserInfo().then(res=>{
        this.userInfo = res.body;
      })
    }
    
  },
  methods: {
    ...mapActions(["logout", "getUserInfo"]),
    async loginOut() {
      let res = await this.logout();
      console.log(res, "lllllllll");
      // this.$forceUpdate();
      this.$router.push({
        path: "/login",
      });
      // this.$router.go(0);
    },
    personCenter() {
      this.$router.push({
        path: "/personCenter",
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.hearder {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: #fff;
  height: 60px;
  line-height: 60px;
  box-sizing: border-box;
  padding: 0 20rem;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,.2);
  .hearder-wrapper {
    display: flex;
    justify-content: space-between;
    .phone-wrapper {
      float: left;
      margin-right: $fontSize32;
      display: flex;
      align-items: center;
      font-size: 16px;
      height: 100%;
      .phone-avatar {
        width: 24px;
        height: 24px;
      }
    }
    .user-avatar {
      width: 32px;
      height: 32px;
      vertical-align: middle;
    }
  }
  a {
    // display: inline-block;
    text-decoration: none;
    margin: 0 0.48rem;
    color: #333333;
    font-size: 16px;
    padding: 18px 0;
    box-sizing: border-box;
  }
}

.router-link-exact-active {
  color: #0069EA !important;
  // border-bottom: 4px solid #0069EA;
}
@media screen and (min-width: 768px) and (max-width: 850px) {
  .header-logo{
    display: none;
  }
}
//  移动端
@media screen and (min-width: 300px) and (max-width: 768px) {
  .hearder {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    background: #fff;
    height: 40px;
    line-height: 40px;
    padding: 0;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,.2);
    .hearder-wrapper {
      display: flex;
      justify-content: space-between;
      .header-logo{
        display: none;
      }
      .phone-wrapper {
        display: none;

        .phone-avatar {
          width: 24px;
          height: 24px;
        }
      }
      .user-avatar {
        width: 24px;
        height: 24px;
        vertical-align: middle;
      }
    }
    a {
      text-decoration: none;
      margin: 0 10px;
      color: #333333;
      font-size: $mFontSize12;
      padding-bottom: 10px;
    }
  }
}
</style>
